/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_List_TitleInputs */

const en_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Metadata`)
};

const fr_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées du projet`)
};

const de_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektmetadaten`)
};

const it_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati del progetto`)
};

const ru_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные проекта`)
};

const es_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos del proyecto`)
};

const zh_cn2_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目元数据`)
};

const ja_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトメタデータ`)
};

const hi_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना मेटाडेटा`)
};

const pt_pt2_options_metadata_list_title = /** @type {(inputs: Options_Metadata_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados do projeto`)
};

/**
* | output |
* | --- |
* | "Project Metadata" |
*
* @param {Options_Metadata_List_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_list_title = /** @type {((inputs?: Options_Metadata_List_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_List_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_list_title(inputs)
	if (locale === "de") return de_options_metadata_list_title(inputs)
	if (locale === "it") return it_options_metadata_list_title(inputs)
	if (locale === "ru") return ru_options_metadata_list_title(inputs)
	if (locale === "es") return es_options_metadata_list_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_list_title(inputs)
	if (locale === "ja") return ja_options_metadata_list_title(inputs)
	if (locale === "hi") return hi_options_metadata_list_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_list_title(inputs)
	return en_options_metadata_list_title(inputs)
});